import React from 'react';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const usePagination = (items, itemsPerPage = 50) => {
    const [currentPage, setCurrentPage] = React.useState(1);
    const totalPages = Math.ceil(items.length / itemsPerPage);
    const paginatedItems = items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    // Reset to page 1 when items change (e.g. filter applied)
    React.useEffect(() => {
        setCurrentPage(1);
    }, [items.length]);

    return { paginatedItems, currentPage, totalPages, setCurrentPage, totalItems: items.length };
};

export const Pagination = ({ currentPage, totalPages, totalItems, setCurrentPage, label = 'éléments' }) => {
    if (totalPages <= 1) return null;

    return (
        <div className="flex items-center justify-between px-2 py-3 border-t border-jungle/10 mt-4" data-testid="pagination-controls">
            <span className="text-sm text-muted-foreground">
                Page {currentPage} / {totalPages} ({totalItems} {label})
            </span>
            <div className="flex gap-2">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                    disabled={currentPage <= 1}
                    className="rounded-xl border-jungle/20"
                    data-testid="pagination-prev"
                >
                    <ChevronLeft className="w-4 h-4 mr-1" />
                    Précédent
                </Button>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                    disabled={currentPage >= totalPages}
                    className="rounded-xl border-jungle/20"
                    data-testid="pagination-next"
                >
                    Suivant
                    <ChevronRight className="w-4 h-4 ml-1" />
                </Button>
            </div>
        </div>
    );
};
